import { render, staticRenderFns } from "./fenlei.vue?vue&type=template&id=2b00f69e&scoped=true&"
import script from "./fenlei.vue?vue&type=script&lang=js&"
export * from "./fenlei.vue?vue&type=script&lang=js&"
import style0 from "./fenlei.vue?vue&type=style&index=0&id=2b00f69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00f69e",
  null
  
)

export default component.exports